<!--
* UIID: UI-UC-110
* UI Name: Add / Modify User Component
* Modify Date: 2022.08.08
-->
<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="dialog-drag-display add-map-layout-dialog custom-add-map-layout-dialog"
  >
    <template v-slot:title>
      <!-- [S]  Popup title-->
      <v-card-title class="headline white--text" primary-title
        >{{ options.item.action }} User Component</v-card-title
      >
    </template>
    <template v-slot:button-close>
      <v-btn small text icon @click="removeDialog">
        <icon-svg iconName="close" />
      </v-btn>
    </template>
    <v-card class="dialog-container comm-custom-mq">
      <!-- [S]  Popup body-->
      <v-card-text class="pb-0">
        <!-- 203705_MapManager_Fix issues_9 -->
        <v-form ref="form" class="dialog-content">
          <v-row class="ml-0 mr-0">
            <v-col class="required-col field-col pt-0 pb-0" lg="1">
              <v-icon x-small>fas fa-asterisk</v-icon>
              <span class="field-label required-text ml-1">{{
                $t('lbl.userComponent.addUserComponent.name')
              }}</span>
            </v-col>
            <v-col lg="6" class="map-text-field pl-0 pt-0 pb-0 pr-4">
              <v-text-field
                v-model="saveData.uc_name"
                :rules="[validationUtils.required, validationUtils.max(50)]"
                :disabled="options.item.action == 'Modify' ? true : false"
                class="data-table-filter-text-field inline-block-component text-field-flatfile-layout map-name-textfield"
                ref="refMapName"
                heigth="30"
                outlined
                dense
                solo
                @blur="validateUCName()"
              ></v-text-field>
            </v-col>
            <v-col class="required-col field-col pt-0 pb-0" lg="1">
              <v-icon x-small>fas fa-asterisk</v-icon>
              <span class="field-label required-text ml-1">{{
                $t('lbl.userComponent.addUserComponent.type')
              }}</span>
            </v-col>
            <v-col lg="4" class="map-text-field pl-0 pt-0 pb-0">
              <v-select
                v-model="saveData.uc_type"
                :label="checkType"
                :rules="[validationUtils.required]"
                :items="types"
                class="data-table-filter-text-field inline-block-component text-field-flatfile-layout user-name-textfield"
                height="30"
                solo
              ></v-select>
            </v-col>
          </v-row>
          <v-row class="ml-0 mr-0">
            <v-col class="required-col field-col pa-0" lg="2">
              <v-icon x-small>fas fa-asterisk</v-icon>
              <span class="field-label required-text ml-1">{{
                $t('lbl.userComponent.addUserComponent.scriptFile')
              }}</span>
            </v-col>
            <v-col lg="10" class="map-text-field inline-block-component pa-0">
              <v-text-field
                v-model="saveData.uc_file_name"
                :rules="[validationUtils.required]"
                class="data-table-filter-text-field inline-block-component text-field-flatfile-layout"
                heigth="30"
                width="100"
                outlined
                dense
                solo
                readonly
              ></v-text-field>
              <v-btn
                @click="openLoadFilePop({ mode: 'Load', filetype: 'script' })"
                class="btn ml-3 btn-popup-search"
                color="primary"
                >{{ $t('btn.mapManager.load') }}</v-btn
              >
            </v-col>
          </v-row>
          <v-row v-if="saveData.uc_type == 'C'" class="ml-0 mr-0 mt-6">
            <v-col cols="12" md="12" class="px-0 pt-0">
              <v-row class="ml-0 mr-0 d-block">
                <v-col class="required-col field-col pt-0 pb-0" lg="6">
                  <span class="field-label required-text ml-1">
                    {{ $t('lbl.userComponent.addUserComponent.req') }}
                  </span>
                </v-col>
                <v-col lg="4" class="pa-0 ml-2"> </v-col>
                <v-col lg="1" class="pa-0 ml-1">
                  <v-icon dense @click="addRequest()"> mdi-plus </v-icon>
                </v-col>
              </v-row>
              <v-form ref="formHttpHeaders" class="dialog-content form-identification px-0">
                <v-row>
                  <v-col cols="12" md="12" class="pa-0 d-flex">
                    <span class="mt-2 mx-4 field-label">Message Use</span>
                    <v-checkbox
                      v-model="messageUse"
                      @change="changeMessageUse(messageUse)"
                      class="custom-select-checkbox mt-0"
                      dense
                      hide-details
                    ></v-checkbox>
                  </v-col>
                </v-row>
                <v-row
                  class="ml-1 mr-0 mb-4 edi-identification user-component-request"
                  v-for="(item, index) in listRequests.slice(1)"
                  :key="item.id"
                >
                  <v-col cols="12" md="6" class="pa-0">
                    <v-tooltip top :disabled="!item.isValidateParam">
                      <template v-slot:activator="{ on }">
                        <div v-on="on">
                          <v-text-field
                            :ref="'RQ_' + item.id"
                            solo
                            hide-details
                            v-model="item.keyRequest"
                            @change="validateParam(item)"
                            :rules="[validationUtils.required]"
                          ></v-text-field>
                        </div>
                      </template>
                      <span v-html="$t('lbl.userSimulator.validDuplicateParam')"></span>
                    </v-tooltip>
                  </v-col>
                  <v-col cols="12" md="5" class="pa-0 pl-2">
                    <v-text-field
                      :ref="'RQ_' + item.id + '_' + item.id"
                      solo
                      hide-details
                      v-model="item.valueRequest"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="1" class="pa-0 pl-3 mt-2">
                    <v-icon dense @click="removeRequest(index)">
                      mdi-minus
                    </v-icon>
                  </v-col>
                </v-row>
              </v-form>
            </v-col>
          </v-row>
        </v-form>
        <v-divider class="ml-0 mr-0 divder-popup" inset></v-divider>
        <v-row class="ml-0 mr-0">
          <v-col class="button-col action-col" lg="12">
            <div class="btn-form-control text-right">
              <v-btn class="btn btn-delete btn-popup" @click="removeDialog">{{
                $t('btn.common.close')
              }}</v-btn>
              <v-btn class="btn btn-popup-search btn-popup" color="primary" @click="onSave">{{
                $t('btn.common.save')
              }}</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [E]  Popup body-->
    </v-card>
    <dialogWindow
      ref="DuplicatePatternDialog"
      size="max"
      :detail="$t('msg.userSimulator.validDuplicate')"
      color="warning"
      @select-ok="removeWariningDialog"
    >
    </dialogWindow>
    <dialogWindow
      ref="messageDialog"
      size="max"
      :info="checkDialogTitle"
      :detail="checkDialogInfo"
      :color="checkDialogColor"
      @select-ok="removeMessageDialog()"
    ></dialogWindow>
  </dialog-drag>
</template>

<script>
import DialogDrag from '@/vue-dlb/components/vue-dialog-drag.vue';
import IconSvg from '@/vue-caas/components/IconBase.vue';
import EventBus from '@/vue-caas/views/process/component/event-bus.js';
import { showProgress, hideProgress } from '@/vue-dlb/utils/sys-util.js';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';

export default {
  components: {
    DialogDrag,
    IconSvg,
    dialogWindow,
  },
  name: 'add-map-layout-dialog',
  props: {
    id: String,
    options: Object,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
  },
  computed: {
    userComponentList() {
      return this.$store.getters.userComponentSelectBoxList;
    },
  },
  data() {
    return {
      saveData: {
        uc_name: '',
        uc_file_name: '',
        uc_type: '',
        uc_conv_req: {},
        uc_file_id: '',
        uc_file_comment: '',
      },
      lastFoldIdInput: '',
      lastFoldIdScript: '',
      types: [
        { text: 'As Connector', value: 'R' },
        { text: 'As Converter', value: 'C' },
      ],
      checkType: '',
      listRequests: [],
      messageUse: false,
      isDuplicatePattern: false,
      setPattern: new Set(),
      checkDialogTitle: '',
      checkDialogColor: 'warning',
      checkDialogInfo: '',
    };
  },
  created() {
    this.$store.dispatch('getUserComponentSelectBoxList');

    let data = this.options.item.data;
    if (this.options.item.action == 'Add') {
      this.listRequests.push({
        id: 0,
        keyRequest: 'attachFile',
        valueRequest: 'false',
        isValidatePattern: false,
      });
      this.setPattern.add('attachFile');
    }
    if (this.options.item.action == 'Modify') {
      if (data.uc_type == 'C') {
        Object.entries(data.uc_conv_req).forEach(([key, value], index) => {
          let item = key.split('_|_');
          this.listRequests.push({
            id: item[1],
            keyRequest: item[0],
            valueRequest: value,
          });
        });
      }

      this.listRequests.sort(function(a, b) {
        return b.id > a.id ? -1 : 1;
      });
      let indexMessUse = this.listRequests.findIndex((e) => e.keyRequest === 'attachFile');
      if (indexMessUse > -1)
        this.messageUse = this.listRequests[indexMessUse].valueRequest === 'true';

      this.saveData = {
        uc_id: data.uc_id,
        uc_name: data.uc_name,
        uc_file_name: data.uc_file_name,
        uc_type: data.uc_type,
        uc_conv_req: data.uc_conv_req,
        uc_file_id: data.uc_file_id,
        uc_file_comment: data.uc_file_comment,
      };
      this.checkType = data.uc_type == 'R' ? 'As Connector' : 'As Converter';
    }
  },
  methods: {
    validateUCName() {
      const isDuplicate = this.userComponentList.some(
        (e) => e.uc_name === this.saveData.uc_name && e.uc_id !== this.saveData.uc_id,
      );
      if (isDuplicate) {
        this.checkDialogInfo = `User Component name : ${this.saveData.uc_name} have been created !`;
        this.checkDialogColor = 'warning';
        this.$refs.messageDialog.dialog = true;
        this.saveData.uc_name = '';
        return false;
      }
      return true;
    },
    resetSetPattern() {
      this.setPattern.clear();
      this.listRequests.map((item) => {
        if (item.keyRequest !== '') {
          this.setPattern.add(item.keyRequest);
        }
      });
    },
    validateParam(itemChange) {
      let indexValid = this.listRequests.findIndex((e) => e.id === itemChange.id);
      if (this.setPattern.has(itemChange.keyRequest)) {
        this.isDuplicateParam = true;
        this.listRequests[indexValid].isValidateParam = true;
      } else {
        this.isDuplicateParam = false;
        this.listRequests[indexValid].isValidateParam = false;
      }
      this.resetSetPattern();
    },
    changeMessageUse(messageUse) {
      this.listRequests[0].valueRequest = messageUse.toString();
    },
    onFileChanged(e) {
      this.saveData.file_id = e[0].FILE_ID;
      this.saveData.uc_file_name = e[0].FILE_NAME;
      this.saveData.file_content = e[0].FILE_CONTENT;
    },
    openLoadFilePop(data) {
      let { mode, filetype } = data;
      let callback = (row) => {
        Store.dispatch('common/viewFileData', row.FILE_ID).then(() => {});
      };
      this.$emit('openLoadFile', {
        mode: 'Load',
        filetype: filetype,
        lastFoldIdInput: this.lastFoldIdInput,
        lastFoldIdScript: this.lastFoldIdScript,
        callback,
        action: 'Add',
      });
    },
    convertArrayObjectToJson(listObject) {
      let jsonFormat;
      if (listObject.length > 0) {
        jsonFormat = listObject.reduce(
          (obj, item) => Object.assign(obj, { [item.keyRequest]: item.valueRequest }),
          {},
        );
      } else {
        jsonFormat = {};
      }
      return jsonFormat;
    },
    onSave() {
      if (!this.validateUCName()) return;
      if (this.isDuplicateParam) {
        this.$refs.DuplicatePatternDialog.dialog = true;
        return -1;
      }
      let indexValid = this.listRequests.findIndex(
        (e) => e.keyRequest === '' || e.valueRequest === '',
      );
      if (indexValid > -1) {
        let itemRequest = this.listRequests[indexValid];
        this.$refs[
          `RQ_${itemRequest.id}${itemRequest.keyRequest === '' ? '' : '_' + itemRequest.id}`
        ][0].focus();
        return -1;
      }
      let validResult = this.$refs.form.validate();
      if (validResult) {
        this.listRequests.map((e) => (e.keyRequest += '_|_' + e.id));
        this.saveData.uc_conv_req = this.convertArrayObjectToJson(this.listRequests);
        showProgress();
        if (this.options.item.action == 'Add') {
          this.$store
            .dispatch('insertUserComponent', this.saveData)
            .then(() => {
              hideProgress();
              this.removeDialogRefesh({});
            })
            .catch(() => {
              hideProgress();
            });
        } else {
          this.$store
            .dispatch('updateUserComponent', this.saveData)
            .then(() => {
              hideProgress();
              this.removeDialogRefesh({});
            })
            .catch(() => {
              hideProgress();
            });
        }
      } else {
        return validResult;
      }
    },
    removeDialogRefesh(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
      EventBus.$emit('refeshListUserComponent');
    },
    removeMessageDialog() {
      this.$refs.messageDialog.dialog = false;
    },
    removeWariningDialog(dialog) {
      this.$refs.DuplicatePatternDialog.dialog = false;
    },
    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
    addRequest() {
      let index =
        this.listRequests.length > 0 ? this.listRequests[this.listRequests.length - 1].id + 1 : 1;
      this.listRequests.push({
        id: index,
        keyRequest: '',
        valueRequest: '',
        isValidateParam: false,
      });
    },
    removeRequest(index) {
      this.listRequests.splice(index, 1);
      this.resetSetPattern();
    },
  },
};
</script>

<style>
.user-name-textfield > .v-input__control > .v-input__slot > .v-select__slot > label.v-label {
  font-size: 13px !important;
}
.edi-identification
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  margin-top: 4px;
}
.v-text-field.v-text-field--solo .v-input__control {
  min-height: 40px;
}
</style>
